import PropTypes from 'prop-types';
import { useState } from 'react';
import { Col, Form, Modal, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { TitleGenerator } from 'utils/TitleGenerator';
import ButtonShareMail from 'utils/buttons/ButtonShareMail';

const EmailShareModal = ({
  type,
  selected,
  setSelected,
  emailModal,
  setShow
}) => {
  const { branchOffices } = useSelector(state => state.branchOffice);
  const { realEstate } = useSelector(state => state.realEstate);

  const [branchOfficeId, setBranchOfficeId] = useState('');

  const GenerateLink = (id, title) => {
    let url;
    if (type === 'project') {
      url = `${
        process.env.REACT_APP_CLIENT_DETAIL_PROJECT
      }${id}/${TitleGenerator(title)}?re=${realEstate.id}&of=${branchOfficeId}`;
    } else {
      url = `${process.env.REACT_APP_CLIENT_DETAIL}${id}/${TitleGenerator(
        title
      )}?re=${realEstate.id}&of=${branchOfficeId}`;
    }
    return url;
  };

  const HandleShare = () => {
    const subject = '🏡 Propiedades de su interés';

    const body =
      'Aquí te envío la lista de propiedades: \n\n' +
      selected
        .map(item => `${item.title} \n ${GenerateLink(item.id, item.title)}`)
        .join('\n\n');

    window.location.href = `mailto:?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    // Empty selected array and close modal
    setSelected([]);
    setShow(false);
  };

  return (
    <Modal show={emailModal} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Compartir propiedad</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group className="mb-3">
          <Form.Label>
            Seleccionar Sucursal <span className="text-danger">*</span>
          </Form.Label>

          <Form.Select
            value={branchOfficeId}
            onChange={e => setBranchOfficeId(e.target.value)}
          >
            <option value="">Seleccionar Sucursal</option>
            {branchOffices.map(branchOffice => (
              <option key={branchOffice.id} value={branchOffice.id}>
                {branchOffice.branch_office_name}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        <div className="px-2">
          <Row>
            <Col xs={12} className="p-md-1">
              <ButtonShareMail
                text="Enviar"
                funcion={HandleShare}
                disabled={!branchOfficeId}
                className="mb-2 mb-md-0 w-100"
              />
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
};

EmailShareModal.propTypes = {
  branchOffices: PropTypes.array,
  type: PropTypes.oneOf(['project', 'property']),
  emailModal: PropTypes.bool,
  setShow: PropTypes.func,
  selected: PropTypes.array,
  setSelected: PropTypes.func
};

export default EmailShareModal;
